import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import { useAuth } from "../features/auth/hooks/useAuth";
import { useOrganization } from "../features/auth/hooks/useOrganization";
import { createBrandedTheme } from "../shared/theme/MainTheme";

/**
 * Provides MUI theme driven by organization branding colors when the user
 * is authenticated and org data is loaded. Otherwise uses default theme.
 */
function BrandedThemeProvider({ children }) {
  const { organizationId } = useAuth();
  const { organization } = useOrganization(organizationId);
  const brandingColors = organization?.brandingColors ?? null;
  const theme = React.useMemo(
    () => createBrandedTheme(brandingColors),
    [brandingColors]
  );
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}

export default BrandedThemeProvider;
